import { ApiClient } from '../../core/http/api_client';

export class SearchRelatedWordItemRepository {
  async sendRequest(encryptedKeyword: String) {
    return ApiClient.get(
      `/searchRelatedWordItem/?searchKeyword=${encryptedKeyword}`, {responseType: "document"}
    );
  }
}
